import { Button, Icon } from "@/shared/ui/";

type Props = {
  onClick: () => void;
};

export default function AccountVipLabel({ onClick }: Props) {
  return (
    <Button type="button" className="shrink-0 text-base gap-2.5 h-13 w-full" onClick={onClick}>
      <Icon name="vip" className="w-5" />
      <span>VIP</span>
    </Button>
  );
}
